import { Component } from '@angular/core'
import { ColumnControlButtonComponent } from '../column-control-button/column-control-button.component'

@Component({
    selector: 'app-column-control-update-button',
    templateUrl: './column-control-update-button.component.html',
    styleUrls: ['./column-control-update-button.component.scss'],
    standalone: false
})
export class ColumnControlUpdateButtonComponent extends ColumnControlButtonComponent {}
